import React from "react";

import "./explore-loading.scss";

import { Shimmer } from "../common/shimmer/shimmer";

export const ExploreLoading = ({isApiLoading}) => {
    const visibilityLoading = !isApiLoading ? 'hidden-458tyu' : ''

    const countNavigation = 7
    const countProducts = 10
    const countOrders = 7
    const countOrdersText = 3

    const renderShimmers = (count, name) => {
        return (
            Array.from({length: count}, (unused, i) => (
                <Shimmer key={i} name={`${visibilityLoading} ${name}`} />
            ))
        )
    }

    return (
        <div className={`explore-loading-pop012 ${visibilityLoading}`}>
            <div className={`navigation-loading ${visibilityLoading}`}>
                {renderShimmers(countNavigation, 'navigation-shimmer')}
            </div>
            <div className={`products-container ${visibilityLoading}`}>
                <Shimmer name={`text ${visibilityLoading}`} />
                <div className={`products-loading ${visibilityLoading}`}>
                    {renderShimmers(countProducts, 'products-shimmer')}
                </div>
            </div>
            <div className={`orders-container ${visibilityLoading}`} >
                <div className={`orders-text-loading ${visibilityLoading}`}>
                    {renderShimmers(countOrdersText, 'text')}
                </div>
                <div className={`orders-loading ${visibilityLoading}`}>
                    {renderShimmers(countOrders, 'orders-shimmer')}
                </div>
            </div>
        </div>
    )
}